var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPass1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_247_4160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.5C12.8135 21.5017 14.1143 21.2438 15.3278 20.7412C16.5413 20.2385 17.6435 19.501 18.571 18.571C19.501 17.6435 20.2385 16.5413 20.7412 15.3278C21.2438 14.1143 21.5017 12.8135 21.5 11.5C21.5017 10.1865 21.2438 8.8857 20.7411 7.67222C20.2385 6.45875 19.501 5.35656 18.571 4.42901C17.6435 3.49902 16.5413 2.76151 15.3278 2.25885C14.1143 1.75619 12.8135 1.49831 11.5 1.50001C10.1865 1.49833 8.8857 1.75623 7.67222 2.25889C6.45875 2.76154 5.35656 3.49904 4.42901 4.42901C3.49904 5.35656 2.76154 6.45875 2.25889 7.67222C1.75623 8.8857 1.49833 10.1865 1.50001 11.5C1.49831 12.8135 1.75619 14.1143 2.25885 15.3278C2.76151 16.5413 3.49902 17.6435 4.42901 18.571C5.35656 19.501 6.45875 20.2385 7.67222 20.7411C8.8857 21.2438 10.1865 21.5017 11.5 21.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.5L10.5 14.5L16.5 8.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_247_4160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.5 -0.5H23.5V23.5H-0.5V-0.5Z",
    fill: "#7D8FB3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass1);
export default __webpack_public_path__ + "static/media/pass1.92c827919f493f942523e3dc2e649f69.svg";
export { ForwardRef as ReactComponent };